import React from 'react';
import styles from './Main.module.scss';
import { GoogleOAuthProvider } from '@react-oauth/google';
import PropTypes from 'prop-types';
import useMediaQuery from '../shared/hooks/useMediaQuery';
import { isMobileQuery } from '../shared/MediaQuery/mediaQueryUtils';

const MainHoc = ({ children }) => {
    const isMobile = useMediaQuery(isMobileQuery);
    return (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <div className={styles.container}>
                {!isMobile && <div className={styles.bg} />}
                {children}
            </div>
        </GoogleOAuthProvider>
    );
};

MainHoc.propTypes = {
    children: PropTypes.node
};

export default MainHoc;
